import React, { forwardRef } from 'react';
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import EndorLabsMappingForm from './EndorLabsMappingForm';

const EndorLabsCredentialsForm = forwardRef((props, ref) => {
    const fields = [{
        name: "apiKey",
        label: "Api Key",
        required: true
    }, {
        name: "secretKey",
        label: "Secret Key",
        type: FieldTypes.PASSWORD,
        required: true
    }]
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={EndorLabsMappingForm}
        />
    )
});

export default EndorLabsCredentialsForm;